import React, { PureComponent } from 'react'

import getConfig from 'next/config'

import { GoogleAnalytics } from '@grandvision/analytics'
import { BloomreachApi, CmsFooter, CmsHeader } from '@grandvision/bloomreach'
import { PageLayout } from '@grandvision/layout'
import { SearchIndex } from '@grandvision/search'

import { isMyAccountEnabled, isSearchEnabled } from '../util/feature-toggle'

declare global {
  interface Window {
    GA_INITIALIZED: boolean
  }
}

type Props = {
  children: React.ReactNode
  pageModel: BloomreachApi.PageModel
  asPath: string
  renderHeader?: boolean
  renderFooter?: boolean
  renderSiteNav?: boolean
  renderSearchBar?: boolean
  preview?: boolean
  isSolaris?: boolean
  labels?: BloomreachApi.LabelResources
}

const handleSearch = (query: string, type: string): void => {
  const { publicRuntimeConfig } = getConfig()
  const { indexes, productIndex } = publicRuntimeConfig.algolia
  let searchRoute: string = ''
  const storeIndex = indexes && indexes.find((index: SearchIndex) => index.type === 'stores')

  switch (type) {
    case 'products':
      searchRoute = `${productIndex.targetPath}${encodeURIComponent(query)}`
      break
    case 'stores':
      searchRoute = `${storeIndex.targetPath}${encodeURIComponent(query)}`
      break
  }

  try {
    window.location.assign(searchRoute)
  } catch (error) {
    console.log(error)
  }
}

class Layout extends PureComponent<Props> {
  static defaultProps = {
    preview: false,
    isSolaris: false,
    renderHeader: true,
    renderFooter: true,
    renderSiteNav: true,
  }

  componentDidMount() {
    const dev = process.env.NODE_ENV !== 'production'

    if (window && !window.GA_INITIALIZED) {
      GoogleAnalytics.initGA('UA-5983208-4', { debug: dev })
      window.GA_INITIALIZED = true
    }
    GoogleAnalytics.logPageView()
  }

  render() {
    const {
      children,
      pageModel,
      asPath,
      isSolaris = false,
      preview = false,
      renderHeader,
      renderFooter,
      renderSiteNav,
    } = this.props

    if (!pageModel) {
      return null
    }

    const header = renderHeader ? (
      <CmsHeader
        pageModel={pageModel}
        asPath={asPath}
        preview={preview}
        isMyAccountEnabled={isMyAccountEnabled}
        isSearchEnabled={isSearchEnabled}
        isSolaris={isSolaris}
        onSubmitSearch={handleSearch}
        renderSiteNav={renderSiteNav}
      />
    ) : (
      undefined
    )

    const footer = renderFooter && <CmsFooter pageModel={pageModel} preview={preview} />

    return (
      <PageLayout isSolaris={isSolaris} header={header} footer={footer} hasSiteNav={renderSiteNav}>
        {children}
      </PageLayout>
    )
  }
}

export default Layout
